<template>
  <div :class="loading ? 'loading' : ''">
    <!--Stats cards-->
    <div class="row">
      <div
        class="col-md-6 col-lg-4 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div
            class="icon-big text-center text-warning"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
        </stats-card>
      </div>
    </div>

    <!-- <blocks/> -->
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import Blocks from "@/components/Blocks";
export default {
  components: {
    StatsCard,
    ChartCard,
    Blocks,
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  created() {
    this.getState();
  },
  data() {
    return {
      loading: true,
      statsCards: [],
    };
  },
  methods: {
    getState() {
      this.loading = true;
      this.$loading(true);
      this.$http
        .get("analytics")
        .then((response) => {
          this.statsCards = response.data;
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
